module.exports = __webpack_public_path__ + "static/media/homepage-announcements.a55fdece.svg";